import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { modalVariants } from "../../../ui/ModalVariant";

interface EditNoteModalProps {
    open: boolean;
    initialNote: string;
    onClose: () => void;
    onSave: (note: string) => void;
    isSaving: boolean;
}

const EditNoteModal: React.FC<EditNoteModalProps> = ({
    open,
    initialNote,
    onClose,
    onSave,
    isSaving,
}) => {
    const [note, setNote] = useState(initialNote);

    useEffect(() => {
        setNote(initialNote);
    }, [initialNote, open]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
            <motion.div
                variants={modalVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
                className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden"
            >
                <div className="px-6 py-4 border-b flex justify-between items-center bg-gray-50">
                    <h3 className="text-lg font-bold text-gray-800">Modifica Note</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="p-6">
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Note
                        </label>
                        <textarea
                            className="w-full border rounded-md p-2 focus:ring-2 focus:ring-mcia_orange focus:border-mcia_orange outline-none min-h-[120px]"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            placeholder="Inserisci qui le note..."
                            disabled={isSaving}
                        />
                    </div>
                </div>

                <div className="px-6 py-4 bg-gray-50 border-t flex justify-end gap-3">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                        disabled={isSaving}
                    >
                        Annulla
                    </button>
                    <button
                        type="button"
                        onClick={() => onSave(note)}
                        className="px-4 py-2 text-sm font-medium text-white bg-mcia_orange rounded-md hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center gap-2"
                        disabled={isSaving}
                    >
                        {isSaving ? (
                            <div className="flex items-center gap-2">
                                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                <span>Salvataggio...</span>
                            </div>
                        ) : (
                            "Salva"
                        )}
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default EditNoteModal;
